import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Auto-recover de chunks obsoletos tras un deploy. Cuando un import() lazy falla
// (la pestaña tenía el index viejo y Vercel ya purgó ese hash de chunk), Vite
// emite 'vite:preloadError'. Recargamos para tomar index + chunks nuevos, con un
// guard temporal anti-bucle (no más de una recarga cada 10s). Evita el error
// boundary "Recargar" que aparecía al desplegar con la pestaña abierta.
window.addEventListener('vite:preloadError', () => {
  const KEY = 'chunk-reload-ts';
  const last = Number(sessionStorage.getItem(KEY) ?? '0');
  if (Date.now() - last < 10000) return;
  try {
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* sessionStorage no disponible · recargamos igual */
  }
  window.location.reload();
});

// PWA service worker registration · Fase 6 · 2026-05-30
// Solo registra en producción y cuando navigator soporta SW (no en SSR/test).
// Mensaje 'navigate' del SW (notification click) → React Router useNavigate handled
// vía window.history.pushState + dispatchEvent.
if (
  'serviceWorker' in navigator &&
  import.meta.env.PROD &&
  window.location.protocol === 'https:'
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('[pwa] SW registration failed', err);
      });
  });

  // Auto-actualización: cuando un Service Worker NUEVO toma el control (tras un
  // deploy), recargamos una sola vez para servir el código fresco. Evita el
  // problema recurrente de "sigo viendo contenido viejo" tras un despliegue.
  let swRefreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (swRefreshing) return;
    swRefreshing = true;
    window.location.reload();
  });

  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'navigate' && typeof event.data.url === 'string') {
      window.history.pushState({}, '', event.data.url);
      // Trigger React Router re-render
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  });
}
